import { useState, useEffect } from "react";
// a helper hook used by the Roles dialogs to detect when the underlying redux state has been updated.
export const useReduxStateUpdated = (versionId, onChange) => {
    const [initialVersionId] = useState(versionId);
    useEffect(() => {
        if (versionId !== initialVersionId) {
            onChange();
        }
    }, [versionId, initialVersionId, onChange]);
};
